export default __webpack_public_path__ + "static/media/Lynn.30104a52.jpg";